import React, {useRef, useState} from "react";
import { useTranslation } from "@/langs/useTranslation";
import MultipleSelector from "@/components/MultipleSelector";
import Modal from '@/components/Modal';
import CategoryTree from './CategoryTreeWrapper';

const DeviceGroups = ({
  name,
  value,
  onChange,
  disabled,
  clearable,
  checkStrictly = true,
  className,
  style,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();
  const [open,setOpen] = useState(false)
  const [state,setState] = useState({
    current: null,
    options: [],
    open: false
  })
  const tree = useRef(null);

  const handleClose = () => {
    setOpen(false)
  };

  const handleConfirm = (keys, nodes) => {
    if(!state.checkedNodes){
      handleClose();
      return
    }
    setState({
      ...state,
      options: [{id:state.checkedNodes.id,name:state.checkedNodes.title}]
    })
    onChange?.({ target: { value: [state.checkedNodes.id], name } });
    handleClose();
  };

  const handleSelect = (checkedKeys, info) => {

    setState({
      ...state,
      current: checkedKeys,
      checkedNodes: info.node
    })
  }

  return (
    <>
      <MultipleSelector
        placeholder={t({ defaultMessage: "选择门店" })}
        options={state.options}
        multiple={false}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        onClick={() => setOpen(true)}
        noDropdown
        clearable={clearable}
        className={className}
        style={style}
      />
      <Modal
        title={t({ defaultMessage: "选择门店" })}
        width={576}
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
      >
        <CategoryTree
          ref={tree}
          showAll={false}
          showSwitch={false}
          collapse={false}
          selectable={true}
          checkStrictly={checkStrictly}
          readOnly
          checkable={false}
          onSelect = {handleSelect}
        />
      </Modal>
    </>
  );
};

export default DeviceGroups;
